// @flow

import Resource from 'speed-js-core/src/api/NestedResource';

export default class ContactDetailResource extends Resource {
    basePath: string = 'entities/entities/{parent}/contact-details/';

    objectPath: string = 'entities/entities/{parent}/contact-details/{ident}/';
}
